/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuscanerrornocredits4Inputs */

const en_menuscanerrornocredits4 = /** @type {(inputs: Menuscanerrornocredits4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enough credits to read the menu.`)
};

const de_menuscanerrornocredits4 = /** @type {(inputs: Menuscanerrornocredits4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht genug Credits zum Einlesen.`)
};

/**
* | output |
* | --- |
* | "Not enough credits to read the menu." |
*
* @param {Menuscanerrornocredits4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuscanerrornocredits4 = /** @type {((inputs?: Menuscanerrornocredits4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuscanerrornocredits4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuscanerrornocredits4(inputs)
	return de_menuscanerrornocredits4(inputs)
});
export { menuscanerrornocredits4 as "menuScanErrorNoCredits" }